import { defineStore } from 'pinia'

const STORAGE_KEY = 'theme'

function resolveInitial() {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'light' || stored === 'dark') return stored
  // 저장된 값이 없으면 시스템 설정과 무관하게 항상 어두운 테마를 기본값으로
  return 'dark'
}

export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: 'dark',
  }),
  getters: {
    isDark: (state) => state.theme === 'dark',
    isLight: (state) => state.theme === 'light',
  },
  actions: {
    init() {
      this.setTheme(resolveInitial())
    },
    setTheme(value) {
      const next = value === 'light' ? 'light' : 'dark'
      this.theme = next
      try {
        localStorage.setItem(STORAGE_KEY, next)
      } catch (_) { /* localStorage may be unavailable */ }
      if (typeof document !== 'undefined') {
        document.documentElement.dataset.theme = next
      }
    },
    toggle() {
      this.setTheme(this.theme === 'dark' ? 'light' : 'dark')
    },
  },
})
